import React from 'react'
import { useTranslation } from 'react-i18next'
import classNames from 'classnames'
import { TFunction } from 'i18next'

import { Loading } from '../../../../global/Loading/Loading'
import { Button } from '../../../../global/button/Button'
import { Text, TextH3 } from '../../../Typography/Typography'
import { ModalDesktop } from '../ModalDesktop'
import { ModalTitle } from '../common/components/ModalTitle'
import { cloneButtonDesktop } from '../common/helpers/button'
import { MessageModalProps } from './MessageModal'

import styles from './MessageModalDesktop.module.scss'

export const MessageModalDesktop: React.FC<MessageModalProps> = (props) => {
  const { title, isLoading = false, description, children, icon, onClose } = props

  const { t } = useTranslation()

  return (
    <ModalDesktop size='xs' onClose={onClose}>
      <header className={classNames('modal-card-head', styles.headerNoTitle)} />
      <section className={classNames('modal-card-body', styles.body)}>
        <Loading isLoading={isLoading} showLoadingIcon>
          <div className={styles.wrapper}>
            <div className={styles.iconWrapper}>
              {icon && <div className={styles.icon}>{icon}</div>}
              {title && (
                <TextH3>
                  <ModalTitle title={title} />
                </TextH3>
              )}
            </div>
            {description && (
              <div className={styles.description}>
                <Text>{description}</Text>
              </div>
            )}
            <div className={styles.column}>{children}</div>
          </div>
        </Loading>
      </section>
      <footer className={classNames('modal-card-foot', styles.footer)}>
        {getButtons(props, t)}
      </footer>
    </ModalDesktop>
  )
}

const getButtons = (props: MessageModalProps, t: TFunction) => {
  if (props.renderFooter) {
    return props.renderFooter(props)
  } else {
    return [
      cloneButtonDesktop(
        <Button appearance='primary' onClick={props.onClose}>
          {t('Close')}
        </Button>
      ),
    ]
  }
}
